import MaterialIcon from '@/components/atom/MaterialIcon';

interface Props {
  navigateToEmergencyContraceptiveScreen: () => void;
}

const EmergencyContraceptiveFeatureSnippet = ({ navigateToEmergencyContraceptiveScreen }: Props) => {
  return (
    <div className={'flex justify-between gap-[16px] py-[16px]'} onClick={navigateToEmergencyContraceptiveScreen}>
      <div className={'flex items-center gap-[16px]'}>
        <img
          alt={'dietInjectionSnippetIcon'}
          src={'/images/search/emergencyContraceptiveSnippetIcon.png'}
          className={'h-[40px] w-[40px]'}
        />
        <div className={'flex flex-col gap-[2px]'}>
          <span className={'typography-ui-17sb text-gray-600'}>사후피임약 진료 예약</span>
          <span className={'typography-ui-13r text-gray-400'}>지금 문 연 병원 확인하고 예약까지 한 번에</span>
        </div>
      </div>
      <MaterialIcon name={'keyboard_arrow_right'} />
    </div>
  );
};

export default EmergencyContraceptiveFeatureSnippet;
